// extracted by mini-css-extract-plugin
module.exports = {"MobileControls":"s40tF","MobileControls__Block":"kfDOh","MobileControls__Modal":"LGhvt","MobileControls__ModalContent":"JUXOI","MobileControls__ListSwitch":"GjTrv"};